module.exports = __webpack_public_path__ + "img/Wp_2066.bdeecd85.png";